function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20 40C8.94234 40 0 31.0669 0 20C0 8.94258 8.93312 0 20 0C31.0577 0 40 8.93312 40 20C40 31.0574 31.0669 40 20 40Z",
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M22.3438 32.8906H17.6562C17.0091 32.8906 16.4844 32.3659 16.4844 31.7188V17.6562C16.4844 17.0091 17.0091 16.4844 17.6562 16.4844H22.3438C22.9909 16.4844 23.5156 17.0091 23.5156 17.6562V31.7188C23.5156 32.3659 22.9909 32.8906 22.3438 32.8906Z",
  fill: "url(#paint1_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M20 14.1406C18.0615 14.1406 16.4844 12.5635 16.4844 10.625C16.4844 8.68648 18.0615 7.10938 20 7.10938C21.9385 7.10938 23.5156 8.68648 23.5156 10.625C23.5156 12.5635 21.9385 14.1406 20 14.1406Z",
  fill: "url(#paint2_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 20,
  y1: 40,
  x2: 20,
  y2: 0,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FD3A84"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFA68D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 20,
  y1: 32.8906,
  x2: 20,
  y2: 16.4844,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFC2CC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFF2F4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 20,
  y1: 14.1406,
  x2: 20,
  y2: 7.10938,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFC2CC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFF2F4"
})));

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.79419b99.svg";
export { ForwardRef as ReactComponent };